// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".height-tabs-window-custom[data-v-433fc9ed]{max-height:calc(100vh - 365px);overflow-y:auto}.sidebar-container[data-v-433fc9ed]{position:relative;overflow:hidden;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
